import type { IFeature2 } from '@/src/components/home.interface';

export const features: IFeature2[] = [
  {
    imageUrl: '',
    title: 'IEP Goal Tracking',
    description:
      'No more carrying binders full of data sheets, AbleSpace allows you to collect data on your goals with a single click.',
    chip: 'Tracking',
    alt: 'Collect & Track IEP Goal Data with a Single Click',
  },
  {
    type: 'nested',
    title: 'Multiple Data Types',
    description:
      'Choose from over 10 data types to track data for all kinds of goals.',
    imageUrl: '',
    chip: '',
    bullets: [
      {
        title: 'Accuracy',
        details:
          'Perfect for goals that require you to track correct and incorrect observations that lead to a percentage accuracy number.',
        image: '/images/datatype/1.png',
        alt: 'Perfect for goals that require accurate percentage calculations based on tracked correct and incorrect observations',
      },
      {
        title: 'Frequency',
        details: 'Perfect for goals which require a count of an activity.',
        image: '/images/datatype/2.png',
        alt: 'A datatype ideal for goals with activity count requirements',
      },
      {
        title: 'Task Analysis',
        details:
          'Perfect for goals that require a step by step completion of a task',
        image: '/images/datatype/3.png',
        alt: 'Datatype ideal for step-by-step task completion goals',
      },
      {
        title: 'Tasks with Prompts',
        details:
          'Perfect for goals that require tracking of a task’s steps along with prompting levels.',
        image: '/images/datatype/4.png',
        alt: 'A datatype for tracking tasks with prompts',
      },
      {
        title: 'And much more...',
        details:
          'Opportunity, Prompting Levels, Rating Scale, Anecdotal, and much more...',
        image: '/images/datatype/5.png',
        alt: 'Multiple datatypes for data collection by special education professionals',
      },
    ],
  },
  {
    imageUrl: '',
    title: 'Graphs',
    description:
      'Choose from over 20 automatically built graphs to visualize progress on your goals.',
    chip: 'Beautiful',
    alt: 'Built-in Graphs to help visualize progress of different goals',
  },

  {
    imageUrl: '',
    title: 'Beautiful pre-built reports',
    description:
      'Data is automatically analyzed and beautiful reports are auto-generated to carry to your next IEP meeting.',
    chip: 'Reporting',
    alt: 'Beautiful goal reports for your next IEP meeting',
  },
  {
    imageUrl: '',
    title: 'Assessments & Progress Monitoring Tools',
    description:
      "Built in screening and progress monitoring assessments allows you to measure progress accurately on a student's skills.",
    chip: 'Assessments',
    alt: 'Monitoring assessments is now effortless',
  },
  {
    imageUrl: '',
    title: 'Service Time Tracking',
    description:
      'Automatically track service time both at a session and goal levels. Service time tracking reports are automatically generated.',
    chip: 'Service Time',
    alt: 'Automatic IEP Service Time tracking, both at Session and Goal level',
  },
  {
    imageUrl: '',
    title: 'Medicaid Billing',
    description:
      'Spending weekends on Medicaid billing is a thing of the past. Medicaid billing notes are auto generated and with a simple copy and paste, you will save hours every week on billing.',
    chip: 'Billing',
    alt: 'Bid farewell to weekend Medicaid billing hassles',
  },
  // {
  //   imageUrl: '',
  //   title: 'IEP Service Time',
  //   description:
  //     'Spending weekends on Medicaid billing is a thing of the past. Medicaid billing notes are auto generated and with a simple copy and paste, you will save hours every week on billing.',
  //   chip: 'Tracking',
  // },
  {
    imageUrl: '',
    title: 'Scheduling',
    description:
      'Schedule sessions, plan for assessments or IEP meetings with our built in calendar.',
    chip: 'Calendar',
    alt: 'Use built-in Calendar for Scheduling',
  },
  {
    imageUrl: '',
    title: 'Collaboration',
    description:
      'Paraprofessionals and assistants can collect data for you. Safe and secure sharing among accounts.',
    chip: 'Team Work',
    alt: ' Safely share information across accounts',
  },
  {
    imageUrl: '',
    title: 'Teaching and Therapy Materials',
    description:
      'With an ever growing library of helpful teaching strategies and therapy materials, you can say goodbye to scouting the web for planning sessions.',
    chip: 'Materials',
    alt: 'Teaching and therapy materials to help plan sessions',
  },
  {
    imageUrl: '',
    title: 'Mobile and iPad apps',
    description:
      'Works on all devices be it your phone, tablet or iPad so you can take data on the go!',
    chip: 'On the Go',
    alt: 'A caseload management tool for SLPs and special ed teachers',
  },
  {
    imageUrl: 'hey',
    title: 'Community',
    description:
      'A powerful community of school-based special ed professionals, ready to help whenever you need it the most.',
    chip: 'Social',
    alt: 'Join our vibrant community of school-based special ed professionals, always ready to lend a helping hand when you need it most.',
  },
  {
    imageUrl: 'hey',
    title: 'For Schools and Districts',
    description:
      'Roll out AbleSpace across your entire school or district to take advantage of its advanced collaboration features, administrative dashboards, and comprehensive training and support options.',
    chip: 'Schools/Districts',
    alt: 'Bring AbleSpace to your entire school or district for advanced collaboration, administrative dashboards, and comprehensive training and support.',
  },
];
